export type Timeslot = {
  startTime?: number | null;
  duration?: number | null;
};

export enum TimeslotEffectOptions {
  AllOccurrences = 'all',
  SingleOccurrence = 'single',
  Cancel = 'cancel',
}
